import { Phone, Mail, MapPin, MessageSquare } from "lucide-react";
import { Link } from "react-router-dom";
import { PHONE_DISPLAY, PHONE_TEL, PHONE_SMS } from "@/lib/contact";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-white/10 bg-[#0a0e15]" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <div className="font-display font-extrabold uppercase text-2xl text-slate-100">
            CJ's <span className="text-[#ff6b00]">Mobile Detailing</span>
          </div>
          <p className="mt-3 text-sm text-slate-400 leading-relaxed">
            Factory-fresh finishes delivered at your driveway. Premium interior & exterior detailing with a $25 deposit.
          </p>
        </div>
        <div>
          <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#ff6b00] mb-3">Contact</div>
          <ul className="space-y-2 text-sm text-slate-300">
            <li>
              <a href={PHONE_TEL} data-testid="footer-call-link" className="flex items-center gap-2 font-display font-bold text-[#ff6b00] hover:opacity-80 transition">
                <Phone className="h-4 w-4" /> {PHONE_DISPLAY}
              </a>
            </li>
            <li>
              <a href={PHONE_SMS} data-testid="footer-text-link" className="flex items-center gap-2 hover:text-slate-100 transition">
                <MessageSquare className="h-4 w-4 text-slate-500" /> Text us anytime
              </a>
            </li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-slate-500" /> cj.mobile.detailingse@gmail.com</li>
            <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-slate-500" /> On-site mobile — Australia</li>
          </ul>
        </div>
        <div>
          <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#ff6b00] mb-3">Hours</div>
          <ul className="space-y-1 text-sm text-slate-300 font-mono">
            <li>MON — SAT · 08:00 – 18:00</li>
            <li>SUN · By appointment</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-4 pb-24 md:pb-4 text-center font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500">
        © 2026 CJ's Mobile Detailing · Built with grit &amp; gloss ·{" "}
        <Link to="/terms" data-testid="footer-terms-link" className="hover:text-[#ff6b00] transition">Terms &amp; Conditions</Link>
      </div>
    </footer>
  );
}
